export default "__VITE_ASSET__96a9f414__"